import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ViewAsSuperAdmin {
  isViewAsSuperAdmin: boolean;
}

const initialState: ViewAsSuperAdmin = {
  isViewAsSuperAdmin: false,
};

const authSlice = createSlice({
  name: 'view-as-super-admin',

  initialState,
  reducers: {
    setIsViewAsSuperAdmin: (
      state: any,
      action: PayloadAction<ViewAsSuperAdmin>,
    ) => {
      const payload = action.payload;
      state.isViewAsSuperAdmin = payload.isViewAsSuperAdmin;
    },
  },
});

export const { setIsViewAsSuperAdmin } = authSlice.actions;

export default authSlice.reducer;
